export default __webpack_public_path__ + "static/media/a2.80f107b7.png";